<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M2.50008 8.95825H17.5001M3.95841 16.0416H16.0417C16.9622 16.0416 17.7084 15.2954 17.7084 14.3749V5.62492C17.7084 4.70444 16.9622 3.95825 16.0417 3.95825H3.95841C3.03794 3.95825 2.29175 4.70444 2.29175 5.62492V14.3749C2.29175 15.2954 3.03794 16.0416 3.95841 16.0416Z" 
    :stroke="stroke || fill" stroke-width="1.5"/>
    <path d="M4.79199 5.91675C5.091 5.91692 5.33301 6.15969 5.33301 6.45874C5.33283 6.75764 5.09089 6.99958 4.79199 6.99976C4.49295 6.99976 4.25018 6.75774 4.25 6.45874C4.25 6.15959 4.49284 5.91675 4.79199 5.91675ZM6.875 5.91675C7.17415 5.91675 7.41699 6.15959 7.41699 6.45874C7.41682 6.75774 7.17405 6.99976 6.875 6.99976C6.57595 6.99976 6.33318 6.75775 6.33301 6.45874C6.33301 6.15959 6.57585 5.91675 6.875 5.91675ZM8.95801 5.91675C9.25716 5.91675 9.5 6.15959 9.5 6.45874C9.49982 6.75774 9.25705 6.99976 8.95801 6.99976C8.65911 6.99958 8.41717 6.75764 8.41699 6.45874C8.41699 6.15969 8.659 5.91692 8.95801 5.91675Z" 
    :fill="stroke || fill" :stroke="stroke || fill" stroke-width="0.25"/>
  </svg>
</template>

<script>
  export default {
    name: 'PlatformIcon',
    props: {
      width: {
        type: Number,
        default: 20
      },
      height: {
        type: Number,
        default: 20
      },
      fill: {
        type: String,
        default: '#5E6678'
      },
      stroke: {
        type: String,
        default: null
      }
    }
  }
</script>
<style scoped lang="css"></style>
